import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientRateAssignmentsApiAdapter, RateAssignment } from '../adapters/ClientRateAssignmentsApiAdapter';

export const useClientRateAssignments = (teamId: number) => {
    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientRateAssignmentsApiAdapter(httpClient);
    }, []);

    const {
        data: rateAssignments = [],
        isLoading,
        error,
        refetch,
    } = useQuery<RateAssignment[]>({
        queryKey: ['clientRateAssignments', teamId],
        queryFn: () => apiAdapter.getRateAssignments(teamId),
        staleTime: 2 * 60 * 1000,
        enabled: teamId > 0,
    });

    // Obtener la asignación activa actual
    const activeAssignment = rateAssignments.find(
        (assignment) => assignment.status === 'active'
    );

    return {
        rateAssignments,
        activeAssignment,
        isLoading,
        error,
        refetch,
    };
};
